import "unfetch/polyfill";

const handleResponse = function (response) {
  if (response.ok) {
    return response;
  } else {
    throw Error(`${response.status} (${response.statusText})`);
  }
};

export class FetchAdapter {
  static get(url, config = {}) {
    const options = Object.assign(
      {
        method: "GET",
        credentials: "include",
        headers: {}
      },
      config
    );

    return FetchAdapter.rawFetch(url, options).then(handleResponse);
  }

  static post(url, config = {}) {
    const options = Object.assign({
      method: "POST",
      credentials: "include",
      headers: {}
    }, config);

    return FetchAdapter.rawFetch(url, options).then(handleResponse);
  }

  static patch(url, config = {}) {
    const options = Object.assign({
      method: "PATCH",
      credentials: "include",
      headers: {}
    }, config);

    return FetchAdapter.rawFetch(url, options).then(handleResponse);
  }

  static rawFetch(url = "", options = {}) {
    return fetch(url, options);
  }
}
